/*
 * Pre-order treatment - theme contract v1.0.1, §3 and §5.
 *
 * WHAT THIS FILE DOES NOT DO: it never decides what is on pre-order. Both
 * halves of the §3 rule (preorders.active == true AND variant.available) are
 * evaluated server-side in Liquid and baked into the js-preorder-map that
 * snippets/preorder-form-fields.liquid renders inside each add-to-cart form.
 * This file only switches between states that map already decided, when the
 * customer changes size without reloading. First paint is always server-
 * rendered, so there is no flash of wrong state.
 *
 * THE HOOK: theme.js updateVariantInput() sets each .formVariantId input and
 * dispatches a bubbling 'change' on it. That happens at the END of
 * variantEvents(), i.e. AFTER the stock button-label handler has written
 * "Add to Bag"/"Sold Out", so re-labelling here always wins.
 *
 * WHY DELEGATED FROM document: the quickview is injected with innerHTML
 * (theme.js:3640). Inline <script> tags inserted that way never execute, so a
 * per-instance initialiser would silently not run in the quickview. A single
 * delegated listener covers the PDP, the quickview and anything else that
 * reuses .formVariantId, including markup that does not exist yet at load.
 *
 * FAILS SILENT: any missing element or unparseable map leaves the server-
 * rendered state untouched rather than degrading the page.
 */
(function () {
  'use strict';

  var LABEL = 'PRE-ORDER';
  var PROP_NAME = 'properties[type]';
  var PROP_VALUE = 'preorder';
  var PROP_SELECTOR = 'input[name="properties[type]"]';

  /* theme.js:3192 restores the generic add-to-cart label 3000ms after a
     successful add. On a pre-order variant that would replace PRE-ORDER with
     "Add to Bag". Re-assert just after it fires. */
  var LABEL_RESTORE_MS = 3100;

  function readMap(form) {
    var el = form.querySelector('.js-preorder-map');
    if (!el) return null;
    try {
      var parsed = JSON.parse(el.textContent);
      return parsed && typeof parsed === 'object' ? parsed : null;
    } catch (e) {
      return null;
    }
  }

  function lookup(form, variantId) {
    var map = readMap(form);
    if (!map) return null;
    var key = String(variantId);
    return Object.prototype.hasOwnProperty.call(map, key) ? String(map[key]) : null;
  }

  function setProperty(form, on) {
    var input = form.querySelector(PROP_SELECTOR);
    if (on) {
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = PROP_NAME;
        input.className = 'js-preorder-property';
        form.appendChild(input);
      }
      input.value = PROP_VALUE;
    } else if (input && input.parentNode) {
      input.parentNode.removeChild(input);
    }
  }

  function setNotice(form, shipDate) {
    var notice = form.querySelector('.js-preorder-notice');
    if (!notice) return;
    var dateEl = notice.querySelector('.js-preorder-date');
    if (shipDate) {
      if (dateEl) dateEl.textContent = shipDate;
      notice.removeAttribute('hidden');
    } else {
      /* §4: with no ship date the notice is omitted rather than shown empty. */
      notice.setAttribute('hidden', 'hidden');
      if (dateEl) dateEl.textContent = '';
    }
  }

  function setLabel(form) {
    var button = form.querySelector('.js-ajax-submit');
    if (button) button.value = LABEL;
  }

  function apply(form, variantId) {
    if (!readMap(form)) return; /* not a pre-order-aware form; leave it alone */
    var shipDate = lookup(form, variantId);
    var on = shipDate !== null;

    if (on) setLabel(form);
    setNotice(form, on ? shipDate : '');
    setProperty(form, on);
  }

  function formOf(el) {
    return el.form || (el.closest ? el.closest('form') : null);
  }

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || !input.classList || !input.classList.contains('formVariantId')) return;
    var form = formOf(input);
    if (form) apply(form, input.value);
  });

  /* Re-assert the label after the theme's post-add-to-cart reset. */
  document.addEventListener('click', function (event) {
    var button = event.target;
    if (!button || !button.classList || !button.classList.contains('js-ajax-submit')) return;
    var form = formOf(button);
    if (!form) return;
    var idInput = form.querySelector('.formVariantId');
    if (!idInput) return;
    if (lookup(form, idInput.value) === null) return;
    setTimeout(function () {
      if (lookup(form, idInput.value) !== null) setLabel(form);
    }, LABEL_RESTORE_MS);
  });
})();
